/* eslint-disable no-duplicate-case */
import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Banner,
  Modal,
  Tabs,
  TextField,
  ChoiceList,
  Icon,
  Card,
} from "@shopify/polaris";

import config from "../../config/config";
import Swal from "sweetalert2";
import { Row, Col } from "reactstrap";
import { MobileAcceptMajor, MobileCancelMajor } from "@shopify/polaris-icons";
import { useSelector } from "react-redux";
import callApi from "../../utils/apiCaller";
import saleoff from "../../assets/bestseller.png";
import pricingTableContent from "./pricingTableContent";

const PlanTable = (props) => {
  const dataSettings = useSelector((state) => state.dataSettings);
  const [stateData, setStateData] = useState({
    selectOptionsOverQuota: "1",
    modalStatus: false,
    rangeDayProcess: "30",
    choosePlan: "",
    chooseSubscription: "monthly",
    tabSelected: 0,
  });

  const [currentPlanLevel, setCurrentPlanLevel] = useState(0);
  const [choosePlanLevel, setChoosePlanLevel] = useState(0);

  const openModal = (plan, subscription) => {
    if (config.role !== "view") {
      if (
        config.platform === "WOO_COMMERCE" ||
        config.shop == "https://www.1001casquettes.com"
      ) {
        if (
          config.wooType == "extension" ||
          config.shop == "https://www.1001casquettes.com"
        ) {
          let params = {
            action: "activePlan",
            subscription: subscription,
            plan: plan,
          };
          callApi("get", params).then((res) => {
            if (res.data.state === 1) {
              window.top.location.replace(res.data.confirmation_url);
              console.log("test");
            } else if (res.data.state === 3) {
              window.location.reload();
              console.log("test");
            } else if (res.data.state === 4) {
              Swal.fire({
                icon: "success",
                title: "Successfully",
                text: res.data.msg,
                showCloseButton: false,
                showConfirmButton: true,
              }).then((result) => {
                if (result.value) {
                  window.location.reload();
                  console.log("test");
                }
              });
            }
          });
        } else {
          let paymentUrl =
            config.rootLink +
            "payment/?shop=" +
            config.shop +
            "&plan=" +
            plan +
            "&website_url=" +
            config.websiteUrl;
          window.location.href = paymentUrl;
          console.log("test");
        }
      } else {
        if (props.type !== "step") {
          switch (plan) {
            case "free":
              setChoosePlanLevel(1);
              break;
            case "basic":
              setChoosePlanLevel(2);
              break;
            case "pro":
              setChoosePlanLevel(3);
              break;
            case "pro_plus":
              setChoosePlanLevel(4);
              break;
            case "unlimited":
              setChoosePlanLevel(5);
              break;
            default:
              setChoosePlanLevel(1);
          }
          setStateData({
            ...stateData,
            modalStatus: true,
            choosePlan: plan,
            chooseSubscription: subscription,
          });
        } else {
          setStateData({
            ...stateData,
            modalStatus: false,
            choosePlan: plan,
            chooseSubscription: subscription,
          });

          let params = {
            action: "activePlan",
            type: plan,
            subscription: subscription,
            dayProcess: 0,
          };
          callApi("get", params).then((res) => {
            if (res.data.state === 2) {
              Swal.fire({
                icon: "success",
                title: "Successfully",
                text: res.data.msg,
                showCloseButton: false,
                showConfirmButton: false,
                timer: 3000,
              }).then((result) => {
                window.location.reload();
              });
            } else {
              window.top.location.replace(res.data.confirmation_url);
            }
          });
        }
      }
    }
  };

  const closeModal = () => {
    setStateData({
      ...stateData,
      modalStatus: false,
    });
  };

  const handleChangeOptionsOverQuota = (value) => {
    setStateData({
      ...stateData,
      selectOptionsOverQuota: value,
    });
  };

  const handleChangeRangeDayProcess = (value) => {
    if (value > 60 && dataSettings.read_all_orders === "0") {
      value = 60;
    }
    setStateData({
      ...stateData,
      rangeDayProcess: value,
    });
  };

  const confirmActivePlan = () => {
    let paramsClick = {
      action: "clickReview",
      type: "click_upgrade",
      note: "table_dashboard",
    };
    callApi("get", paramsClick).then(async (res) => {});

    activePlan(stateData.choosePlan);
  };

  const activePlan = async (value) => {
    if (config.checkLocalStorage) {
      localStorage.setItem(config.shop + "-synctrack-plan", dataSettings.plan);
    }
    var dayProcess = stateData.rangeDayProcess;
    if (stateData.selectOptionsOverQuota[0] === "2") {
      dayProcess = 0;
    }
    let params = {
      action: "activePlan",
      type: value,
      subscription: stateData.chooseSubscription,
      dayProcess: dayProcess,
    };
    callApi("get", params).then((res) => {
      setStateData({
        ...stateData,
        modalStatus: false,
      });
      if (res.data.state === 2) {
        Swal.fire({
          icon: "success",
          title: "Successfully",
          text: res.data.msg,
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        }).then((result) => {
          window.top.location.reload();
        });
      } else {
        window.top.location.replace(res.data.confirmation_url);
      }
    });
  };

  const handleTabChange = (value) => {
    setStateData({
      ...stateData,
      tabSelected: value,
    });
  };

  useEffect(() => {
    switch (dataSettings.plan) {
      case "free":
        setCurrentPlanLevel(1);
        break;
      case "basic":
        setCurrentPlanLevel(2);
        break;
      case "pro":
        setCurrentPlanLevel(3);
        break;
      case "pro_plus":
        setCurrentPlanLevel(4);
        break;
      case "unlimited":
        setCurrentPlanLevel(5);
        break;
      default:
        setCurrentPlanLevel(1);
    }
  }, [dataSettings]);

  const tabs = [
    {
      id: "pay-monthlty",
      content: "Pay monthly",
    },
    {
      id: "pay-annually",
      content: (
        <div>
          Pay Annually <span>save up to 30%</span>
        </div>
      ),
    },
  ];

  return (
    <div className="plan-table mt-4">
      {config.platform !== "WOO_COMMERCE" ? (
        <Tabs
          fitted
          tabs={tabs}
          selected={stateData.tabSelected}
          onSelect={handleTabChange}
        ></Tabs>
      ) : null}
      <div className="plan-layout" style={{ overflowX: "auto" }}>
        {stateData.tabSelected === 0 ? (
          <table className="plan-layout-table">
            <tbody>
              <tr>
                <th
                  style={{
                    width: "20%",
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                >
                  Plan Table
                </th>
                <th
                  style={{
                    width: "16%",
                    textAlign: "center",
                  }}
                  className="active"
                >
                  <div className="plan-layout-table-name">FREE</div>
                  <div className="plan-layout-table-price">0 $</div>
                  <div className="plan-layout-table-noti">per/month</div>
                  <div className="plan-layout-table-noti mt-3">
                    billed monthly
                  </div>
                </th>
                {pricingTableContent.priceMonthly.map(function (value, index) {
                  return (
                    <th
                      key={index}
                      style={{
                        width: "16%",
                        textAlign: "center",
                      }}
                      className={
                        dataSettings.plan === "basic" &&
                        dataSettings.subscription === "monthly"
                          ? "active"
                          : ""
                      }
                    >
                      {value.plan === "PRO" ? (
                        <img
                          className="best-seller"
                          src={saleoff}
                          alt="best seller"
                        />
                      ) : null}
                      <div className="plan-layout-table-name">{value.plan}</div>
                      <div className="plan-layout-table-price">
                        {value.price} $
                      </div>
                      <div className="plan-layout-table-noti">per/month</div>
                      <div className="plan-layout-table-noti mt-3">
                        billed monthly
                      </div>
                    </th>
                  );
                })}
              </tr>
              {pricingTableContent.features.map(function (value, index) {
                return (
                  <tr>
                    <td className="text-left">{value.content}</td>
                    <td>
                      {value.free == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.free == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.free
                      )}
                    </td>
                    <td>
                      {value.basic == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.basic == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.basic
                      )}
                    </td>
                    <td>
                      {value.pro == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.pro == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.pro
                      )}
                    </td>
                    <td>
                      {value.pro_plus == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.pro_plus == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.pro_plus
                      )}
                    </td>
                    <td>
                      {value.unlimited == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.unlimited == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.unlimited
                      )}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td className="text-left">Status</td>
                {pricingTableContent.listPlan.map(function (value, index) {
                  return (
                    <td>
                      {dataSettings.plan === value ? (
                        <Badge status="success" progress="complete">
                          Activated
                        </Badge>
                      ) : (
                        <Button
                          primary
                          onClick={() => openModal(value, "monthly")}
                        >
                          Choose Plan
                        </Button>
                      )}
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        ) : (
          <table className="plan-layout-table">
            <tbody>
              <tr>
                <th
                  style={{
                    width: "20%",
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                >
                  Plan Table
                </th>
                {pricingTableContent.priceAnnual.map(function (value, index) {
                  return (
                    <th
                      key={index}
                      style={{
                        width: "16%",
                        textAlign: "center",
                      }}
                      className={
                        dataSettings.plan === "basic" &&
                        dataSettings.subscription === "monthly"
                          ? "active"
                          : ""
                      }
                    >
                      {value.plan === "PRO" ? (
                        <img
                          className="best-seller"
                          src="https://i.imgur.com/5duycpi.png"
                          alt="best seller"
                        />
                      ) : null}
                      <div className="plan-layout-table-name">{value.plan}</div>
                      <div className="plan-layout-table-price">
                        {value.price} $
                      </div>
                      <div className="plan-layout-table-noti">per/month</div>
                      <div className="plan-layout-table-noti mt-3">
                        {value.total} $ billed annually
                      </div>
                    </th>
                  );
                })}
              </tr>
              <tr>
                <td className="text-left">Discount</td>
                <td>30%</td>
                <td>30%</td>
                <td>30%</td>
                <td>30%</td>
              </tr>
              {pricingTableContent.features.map(function (value, index) {
                return (
                  <tr>
                    <td className="text-left">{value.content}</td>
                    <td>
                      {value.basic == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.basic == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.basic
                      )}
                    </td>
                    <td>
                      {value.pro == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.pro == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.pro
                      )}
                    </td>
                    <td>
                      {value.pro_plus == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.pro_plus == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.pro_plus
                      )}
                    </td>
                    <td>
                      {value.unlimited == "icon_cancle" ? (
                        <Icon color="critical" source={MobileCancelMajor} />
                      ) : value.unlimited == "icon_check" ? (
                        <Icon color="success" source={MobileAcceptMajor} />
                      ) : (
                        value.unlimited
                      )}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td className="text-left">Status</td>
                {pricingTableContent.listPlan.map(function (value, index) {
                  if (value != "free") {
                    return (
                      <td>
                        {dataSettings.plan === value &&
                        dataSettings.subscription === "annually" ? (
                          <Badge status="success" progress="complete">
                            Activated
                          </Badge>
                        ) : (
                          <Button
                            primary
                            onClick={() => openModal(value, "annually")}
                          >
                            Choose Plan
                          </Button>
                        )}
                      </td>
                    );
                  }
                })}
              </tr>
            </tbody>
          </table>
        )}
      </div>
      {currentPlanLevel > choosePlanLevel ? (
        <Modal
          open={stateData.modalStatus}
          onClose={closeModal}
          title="Are you sure?"
          primaryAction={{
            content: "Confirm, I understand the risk",
            onAction: confirmActivePlan,
          }}
          secondaryActions={[
            {
              content: "Leave it now",
              onAction: closeModal,
            },
          ]}
        >
          <Modal.Section>
            <div className="plan-table">
              Please confirm this downgrade plan may affect immediately to{" "}
              <b>the number of orders tracking syncing to Paypal</b>. And you
              need to <b>reconnect the sub-stores</b> if you are using{" "}
              <b>Multi-stores integration</b>
            </div>
          </Modal.Section>
        </Modal>
      ) : (
        <Modal
          open={stateData.modalStatus}
          onClose={closeModal}
          title="Would you like to process the old orders? "
          primaryAction={{
            content: "Active Plan",
            onAction: confirmActivePlan,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: closeModal,
            },
          ]}
        >
          <Modal.Section>
            <div className="plan-table">
              <ChoiceList
                choices={[
                  {
                    label: (
                      <div
                        className="d-flex plan-table"
                        style={{ lineHeight: "36px" }}
                      >
                        Process the old orders in last{" "}
                        <div className="ml-2 mr-2">
                          <TextField
                            type="number"
                            value={stateData.rangeDayProcess}
                            onChange={handleChangeRangeDayProcess}
                            max={
                              dataSettings.read_all_orders === "0" ? 60 : 365
                            }
                          />
                        </div>
                        days (max 365 days)
                      </div>
                    ),
                    value: "1",
                  },
                  {
                    label: "Skip the old orders",
                    value: "2",
                  },
                ]}
                selected={stateData.selectOptionsOverQuota}
                onChange={handleChangeOptionsOverQuota}
              />
            </div>
            <div className="mt-3">
              <Banner title="Note">
                <p>
                  - The old orders will be count to your number of usage this
                  month.
                  <br />- If you are using multi-store integration, the
                  subscription fee will apply to your main store.
                </p>
              </Banner>
            </div>
          </Modal.Section>
        </Modal>
      )}
    </div>
  );
};

export default PlanTable;
